
export class Lookup {
    constructor(id: string, name: string= '', logicalName: string= '') {
        this.Id = id;
        this.Name = name;
        this.Logicalname = logicalName;
    }
    public Id: string;
    public Name: string;
    public Logicalname: string;
}
